import React from "react";
import * as c from "./exploreBusiness.module.scss";
import { Link } from "gatsby";
import { IconCaretRight } from "@components/icons/IconCaretRight";

const ExploreBusiness = ({ businessTypes: { listItems } }) => {
  return (
    <div className={c.container}>
      <div className={c.businessTypesList}>
        {listItems.map(({ url, title }) => (
          <Link className={c.businessType} to={url} key={url}>
            <h4 className={c.title}>{title}</h4>
            <div className={c.caret}>
              <IconCaretRight isRedesign stroke="#191E49" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ExploreBusiness;
